// Constants used throughout the application

// Drawer width for the sidebar menu
export const drawerWidth = 280;